export default __webpack_public_path__ + "static/media/txt1_pc@2x.c2396514.png";